.tabBar {
  flex: none;
  display: flex;
  height: var(--toolbar-height);
  font-size: 1.25rem;
  background-color: var(--primary-lighter);
}

.tab {
  composes: btnClean from './utils.module.css';
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--toolbar-height);
  padding: 0.25rem 0 0.25rem;
  border-bottom: solid 0.25rem transparent;
  background-color: var(--primary-lighter, aliceblue);
}

.tab:hover {
  background-color: var(--primary-light);
  border-bottom-color: var(--primary);
}

.tab[aria-selected='true'] {
  border-bottom-color: var(--primary-dark);
}
